import getGeneList from './getGeneList';

/* eslint-disable-next-line import/prefer-default-export */
export { getGeneList };